export function duplicateAssetDraft(asset) {
  return {
    id: 0,
    customerId: asset.customerId,
    centerId: asset.centerId,
    code: ``,
    name: asset.name || ``,
    commercialName: asset.commercialName || ``,
    serial: ``,
    type: asset.type || ``,
    assetClass: asset.assetClass || ``,
    brand: asset.brand || ``,
    features: asset.features || ``,
    location: asset.location || ``,
    updatedOn: ``,
    supplier: asset.supplier || ``,
    seller: asset.seller || ``,
    warrantyFrom: asset.warrantyFrom || ``,
    warrantyTo: asset.warrantyTo || ``,
    domainGroup: asset.domainGroup || ``,
    notes: asset.notes || ``,
    active: true,
    externalId: ``,
    version: 1,
    duplicatedFrom: asset.name || asset.code || `activo original`
  };
}
